module.exports = __webpack_public_path__ + "img/canvas-evening-warm.a0ab2c95.jpg";